import LinkIcon from "@mui/icons-material/Link";
import InputAdornment from "@mui/material/InputAdornment";
import { isValidURL } from "core/utils/isValidURL";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ReactHookTextField,
  type ReactHookTextFieldProps,
} from "./ReactHookTextField";

export function ReactHookURLInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ ...props }: ReactHookTextFieldProps<TFieldValues, TName>) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:ReactHookWebAddressInput",
  });
  return (
    <ReactHookTextField
      {...props}
      textFieldProps={{
        ...props.textFieldProps,
        slotProps: {
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <LinkIcon />
              </InputAdornment>
            ),
          },
        },
      }}
      rules={{
        validate: (v) => {
          if (!v) {
            return true;
          }
          return isValidURL(v) || t("invalidURL");
        },
      }}
    />
  );
}
